import { Text } from "@ui-kitten/components";
import Button from "components/Button";
import Chevron from "components/Chevron";
import { LIGHT_BLUE } from "constants/";
import React from "react";
import { Modal, Pressable, ScrollView, View } from "react-native";

interface AutoRenewalDisclosureModalProps {
  visible: boolean;
  onClose: () => void;
  agreementBody: string;
  // When provided, renders an accept button so the modal can collect consent
  onAccept?: () => void;
  acceptText?: string;
}

const AutoRenewalDisclosureModal: React.FC<AutoRenewalDisclosureModalProps> = ({
  visible,
  onClose,
  agreementBody,
  onAccept,
  acceptText = "AGREE & ENABLE AUTO-RENEWAL",
}) => {
  return (
    <Modal visible={visible} animationType="slide">
      <View style={{ flex: 1 }}>
        <Pressable
          onPress={onClose}
          style={{
            flexDirection: "row",
            alignItems: "center",
            paddingLeft: 5,
            paddingTop: 5,
          }}
        >
          <Chevron direction="left" color={LIGHT_BLUE} />
          <Text status="info">Back</Text>
        </Pressable>
        <ScrollView
          contentContainerStyle={{ padding: 16, paddingBottom: 32 }}
          style={{ flex: 1 }}
        >
          <Text category="h5" style={{ marginBottom: 16 }}>
            Auto-Renewal Disclosure and Consent
          </Text>
          <Text style={{ lineHeight: 22, color: "#333" }}>{agreementBody}</Text>
        </ScrollView>
        {onAccept && (
          <View style={{ padding: 16 }}>
            <Button testID="auto-renewal-accept-button" onPress={onAccept}>
              {acceptText}
            </Button>
          </View>
        )}
      </View>
    </Modal>
  );
};

export default AutoRenewalDisclosureModal;
